module.exports = __webpack_public_path__ + "img/login.1ad8a85c.png";